import * as React from "react";
import Box from "@mui/material/Box";
import clsx from "clsx";
import css from './OperationalContact.module.css';
import {ContactRole, OperationContactApi, OperationContactRec, OperationContactSave} from "./OperationContactApi.ts";
import {useEffect} from "react";
import {OperationalContactView} from "./OperationalContactView.tsx";
import {OperationalContactEdit} from "./OperationalContactEdit.tsx";
import Profile from "../Model/Profile.ts";


export interface OperationalContactProps {
    profile: Profile;
    token: string;
    menuIx: number;
    edit: boolean;
    setEdit: (edit:boolean) => void;
    onChanged: (changed: boolean) => void
}

export const OperationalContact: React.FC<OperationalContactProps> = (props: OperationalContactProps) => {

    const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
    const [contacts, setContacts] = React.useState<OperationContactRec[]>([]);
    const [contactRole, setContactRole] = React.useState<ContactRole>({});
    const [saveStatus, setSaveStatus] = React.useState<OperationContactSave[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const api = new OperationContactApi(props.token, props.profile);
            try {
                const rolesData = await api.contactRole();
                setContactRole(rolesData ?? []);
                setIsLoaded(true);
            } catch (e) {
                console.error("Błąd podczas pobierania danych.", e);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        setContacts([])
        setIsLoaded(false);
    }, [props.profile]);

    useEffect(() => {
        const fetchData = async () => {
            if (isLoaded) {
                return;
            }

            const api = new OperationContactApi(props.token, props.profile);
            try {
                const contactsData = await api.contactList();
                setContacts(contactsData ?? []);
                setIsLoaded(true);
            } catch (e) {
                setContacts([]);
                setIsLoaded(false);
                console.error("Błąd podczas pobierania danych.", e);
            }
        };

        fetchData();
    }, [isLoaded, contacts, props.profile]);

    useEffect(() => {
        console.log(contacts);
    }, [contacts]);

    useEffect(() => {
        console.log(contactRole);
    }, [contactRole]);

    useEffect(() => {
        console.log(props.edit);
    }, [props.edit]);


    const onDelete = async (ids: number[]) => {
        const api = new OperationContactApi(props.token, props.profile);
        try {
            const saved = await api.remove(ids);
            setSaveStatus(saved);
        } catch (e) {
            console.error("Błąd podczas zapisu kontaktów operacyjnych.", e);
        }
    }


    const onSave = async (contacts: OperationContactRec[]) => {
        const api = new OperationContactApi(props.token, props.profile);
        try {
            const saved = await api.save(contacts);
            setSaveStatus(saved);
        } catch (e) {
            console.error("Błąd podczas zapisu kontaktów operacyjnych.", e);
        }
    }


    const onUpdate = async (contacts: OperationContactRec[], ids: number[]) => {
        const api = new OperationContactApi(props.token, props.profile);
        try {
            const saved = await api.update(contacts, ids);
            setSaveStatus(saved);
        } catch (e) {
            console.error("Błąd podczas aktualizacji kontaktów operacyjnych.", e);
        }
    }


    const onCancel = () => {
        props.setEdit(false);
    }


    const drawContactsEdit = () => {
        return (
            <OperationalContactEdit
                contacts={contacts}
                contactRole={contactRole}
                onSave={(contacts) => {console.log(contacts); onSave(contacts)}}
                onDelete={(ids) => {console.log(ids); onDelete(ids)}}
                onUpdate={(contacts, ids) => {console.log(contacts, ids); onUpdate(contacts, ids)}}
                onCancel={onCancel}
                saveStatus={saveStatus}
                onChanged={(changed) => {console.log(changed); props.onChanged(changed)}}
            />
        );
    }


    const drawContactsView = () => {
        return (
            <OperationalContactView contacts={contacts ?? []} roleDef={contactRole ?? {}}/>
        )
    }


    return (

        <Box className={clsx(css.operationContact)} aria-label="OperationalContact">

            {!isLoaded ? (
                <></>
            ) : props.edit ? (
                drawContactsEdit()
            ) : (
                drawContactsView()
            )}

        </Box>
    );
};
